const originalXhr = window.XMLHttpRequest

let blockedFirstSingularRequest = false

export function resetBlockedFirstSingularRequest() {
  blockedFirstSingularRequest = false
}

class PatchedXMLHttpRequest extends originalXhr {
  __url: string | null = null
  constructor() {
    super()
    this.__url = null
  }

  open(method: string, url: string | URL): void
  open(
    method: string,
    url: string | URL,
    async: boolean,
    username?: string | null,
    password?: string | null
  ): void
  open(
    method: string,
    url: string | URL,
    async: boolean = true,
    username?: string | null,
    password?: string | null
  ): void {
    super.open(method, url, async, username, password)
    this.__url = url.toString()
  }

  send(body?: Document | XMLHttpRequestBodyInit | null): void {
    if (
      this.__url?.includes('singular.net') &&
      this.__url.includes('__PAGE_VISIT__') &&
      !blockedFirstSingularRequest
    ) {
      this.ontimeout?.(new ProgressEvent('timeout'))
      // @ts-ignore
      window.singularSdk._singularInstance._apiManager._storageQueue.dequeue()
      // @ts-ignore
      setTimeout(() => {
        // @ts-ignore
        window.singularSdk._singularInstance._apiManager._startSendingApis()
      }, 100)
      blockedFirstSingularRequest = true
      return
    }

    super.send(body)
  }
}

window.XMLHttpRequest = PatchedXMLHttpRequest
